import { FaAngleRight } from "react-icons/fa";
import { Link, useLocation, useParams } from "react-router-dom";
import {  packageDetails } from '../data/Destination';

export default function Breadcrumb({ title, destination, groupTour, variant = "default" }) {
    const { slug } = useParams();
    const pkg = packageDetails?.find((p) => p?.slug === slug);
    const grouppkg = packageDetails?.find((p) => p?.slug === slug);
    const location = useLocation();
    const isGroupTourPage = location.pathname.includes("/group-tour");
    const spacingMap = {
        // home: "lg:px-5 xl:px-0",
        packages: "md:px-9 lg:px-9 xl:px-9 ",
        destinationpackages: "md:px-7 lg:px-9 xl:px-9 mt-4",
        groupTour: "md:px-3 lg:px-3 xl:px-3",
        default: "md:px-1 lg:px-1 xl:px-1",
    };
    const styleMapBgColor = {
        packages: "bg-white",
        destinationpackages: "bg-white",
        groupTour: "bg-white",
        default: "bg-[#0B1C3D] ",
    };
    const styleMapTextColor = {
        packages: "text-[#0B1C3D]",
        destinationpackages: "text-[#0B1C3D]",
        groupTour: "text-[#0B1C3D]",
        default: "text-white",
    };
    return (
        <div className={`max-md:hidden pt-2   ${spacingMap[variant]}`}>
            <div className={`pl-2 text-start transform -skew-x-12 border-l-8  ${styleMapBgColor[variant]}   rounded-r-full border-[#D4AF37] wow fadeInUp max-sm:w-[100%] xl:w-[60%] `}
                data-wow-delay="0.1s"
            // style={{ boxShadow: ' 0px 0px 20px 5px  rgb(0 0 0 / 32%)' }}
            >
                <div className={`text-[12px] ${styleMapTextColor[variant]}  flex items-center   poppins `}>
                    <div className="flex "> {/* Container alignment adjust karein */}
                        <a
                            href={`/`}
                            rel="noopener noreferrer"
                            className="no-underline "
                        >
                            <button
                                type="submit"
                                className={`
                                relative z-10 overflow-hidden group flex items-center justify-center 
                                   isolation-auto transition-all duration-200
                                
                                /* Colors */
                                 ${styleMapTextColor[variant]}
                                
                                /* Responsive Sizing (Mobile first) */
                                px-2 py-1 text-sm           /* Default: Mobile */
                                sm:px-2 sm:py-1 sm:text-base /* Tablets */
                                lg:px-2 lg:py-1 lg:text-lg   /* Desktop */
                                lg:font-semibold
                                
                                /* Hover Effect Logic */
                            hover:!text-[#D4AF37]
                                `}
                            >
                                <span className="whitespace-nowrap">Home</span>
                            </button>
                        </a>
                    </div>
                    <FaAngleRight className="text-lg" />
                    {!isGroupTourPage && <div className="flex "> {/* Container alignment adjust karein */}
                        <Link
                            to={`/packages`}
                            rel="noopener noreferrer"
                            className="no-underline "
                        >
                            <button
                                type="submit"
                                className={`
                                relative z-10 overflow-hidden group flex items-center justify-center 
                                 isolation-auto transition-all duration-200
                                
                               /* Colors */
                                  ${styleMapTextColor[variant]}
                                
                                /* Responsive Sizing (Mobile first) */
                                px-2 py-1 text-sm           /* Default: Mobile */
                                sm:px-2 sm:py-1 sm:text-base /* Tablets */
                                lg:px-2 lg:py-1 lg:text-lg   /* Desktop */
                                lg:font-semibold
                                
                                /* Hover Effect Logic */
                            hover:!text-[#D4AF37]
                                `}
                            >
                                <span className="whitespace-nowrap">Packages</span>
                            </button>
                        </Link>
                    </div>}
                    {destination && !isGroupTourPage && (
                        <>
                            <FaAngleRight className="text-lg" />
                            <div className="flex "> {/* Container alignment adjust karein */}
                                <Link
                                    to={`/packages/${(pkg?.destination || destination)?.toLowerCase()}`}
                                    rel="noopener noreferrer"
                                    className="no-underline "
                                >
                                    <button
                                        type="submit"
                                        className={`
                                relative z-10 overflow-hidden group flex items-center justify-center 
                                 isolation-auto transition-all duration-200
                                capitalize
                                
                                /* Colors */
                                  ${styleMapTextColor[variant]}
                                
                                /* Responsive Sizing (Mobile first) */
                                px-2 py-1 text-sm           /* Default: Mobile */
                                sm:px-2 sm:py-1 sm:text-base /* Tablets */
                                lg:px-2 lg:py-1 lg:text-lg   /* Desktop */
                                lg:font-semibold
                                
                                /* Hover Effect Logic */
                                hover:!text-[#D4AF37]
                    `}
                                    >
                                        <span className="whitespace-nowrap">{destination} Tour Packages</span>
                                    </button>
                                </Link>
                            </div>
                        </>
                    )}
                    {/* DESTINATION (OPTIONAL) */}
                    {isGroupTourPage && (
                        <>
                            {!isGroupTourPage && <FaAngleRight className="text-lg" />}
                            <div className="flex "> {/* Container alignment adjust karein */}
                                <Link
                                    to={`/group-tour`}
                                    rel="noopener noreferrer"
                                    className="no-underline "
                                >
                                    <button
                                        type="submit"
                                        className={`
                                relative z-10 overflow-hidden group flex items-center justify-center 
                                 isolation-auto transition-all duration-200
                                capitalize
                                
                                /* Colors */
                                  ${styleMapTextColor[variant]}
                                
                                /* Responsive Sizing (Mobile first) */
                                px-2 py-1 text-sm           /* Default: Mobile */
                                sm:px-2 sm:py-1 sm:text-base /* Tablets */
                                lg:px-2 lg:py-1 lg:text-lg   /* Desktop */
                                lg:font-semibold
                                
                                /* Hover Effect Logic */
                                hover:!text-[#D4AF37]
                    `}
                                    >
                                        <span className="whitespace-nowrap">Group Tour Packages</span>
                                    </button>
                                </Link>
                            </div>
                        </>
                    )}
                    {destination && isGroupTourPage && (
                        <>
                            <FaAngleRight className="text-lg" />
                            <div className="flex "> {/* Container alignment adjust karein */}
                                <Link
                                    to={`/group-tour/${(grouppkg?.destination || destination)?.toLowerCase()}`}
                                    rel="noopener noreferrer"
                                    className="no-underline "
                                >
                                    <button
                                        type="submit"
                                        className={`
                                relative z-10 overflow-hidden group flex items-center justify-center 
                                 isolation-auto transition-all duration-200
                                capitalize
                                
                                /* Colors */
                                  ${styleMapTextColor[variant]}
                                
                                /* Responsive Sizing (Mobile first) */
                                px-2 py-1 text-sm           /* Default: Mobile */
                                sm:px-2 sm:py-1 sm:text-base /* Tablets */
                                lg:px-2 lg:py-1 lg:text-lg   /* Desktop */
                                lg:font-semibold
                                
                                /* Hover Effect Logic */
                                hover:!text-[#D4AF37]
                    `}
                                    >
                                        <span className="whitespace-nowrap">{destination}</span>
                                    </button>
                                </Link>
                            </div>
                        </>
                    )}
                    {/* TITLE */}
                    {title && (
                        <>
                            <FaAngleRight className="text-lg" />
                            <div className="flex "> {/* Container alignment adjust karein */}
                                <button
                                    type="submit"
                                    className={`
                                relative z-10 overflow-hidden group flex items-center justify-center 
                                 isolation-auto transition-all duration-200
                                
                               /* Colors */
                                 ${styleMapTextColor[variant]}
                                
                                /* Responsive Sizing (Mobile first) */
                                px-2 py-1 text-sm           /* Default: Mobile */
                                sm:px-2 sm:py-1 sm:text-base /* Tablets */
                                lg:px-2 lg:py-1 lg:text-lg   /* Desktop */
                                lg:font-semibold
                                
                                /* Hover Effect Logic */
                                hover:!text-[#D4AF37]
                                `}
                                >
                                    <span className="whitespace-nowrap">{title}</span>
                                </button>
                            </div>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
}